import { UserRolesDto } from '@/endpoints/models'

import {
	hasAppRole,
	isPrivilegedUser,
	isRealmAdmin,
	isRealmReader,
	isSupportUser,
} from './locking'

export {
	hasAppRole,
	isPrivilegedUser,
	isRealmAdmin,
	isRealmReader,
	isSupportUser,
}

export function canManageUsers(): boolean {
	return (
		hasAppRole(UserRolesDto.RolesEnum.MANAGE_USERS) || isRealmAdmin()
	)
}

export function canManageLOVs(): boolean {
	return hasAppRole(UserRolesDto.RolesEnum.MANAGE_LOV) || isRealmAdmin()
}

/** Matches backend `@isTemplateManager`: ADMIN / SUPER_ADMIN / MANAGE_TEMPLATES / SUPPORT. */
export function canManageTemplates(): boolean {
	return (
		hasAppRole(UserRolesDto.RolesEnum.MANAGE_TEMPLATES) ||
		isPrivilegedUser()
	)
}

export function canCreateSystem(): boolean {
	return hasAppRole(UserRolesDto.RolesEnum.CREATE_DELETE_SYSTEM)
}

export function canDeleteSystem(): boolean {
	return canCreateSystem()
}

export function canForceUnlock(): boolean {
	return (
		hasAppRole(UserRolesDto.RolesEnum.FORCE_UNLOCK) ||
		isPrivilegedUser()
	)
}

/** Any settings section the user may open (nav + settings tree). */
export function canSeeSettings(): boolean {
	return (
		canManageUsers() ||
		canManageLOVs() ||
		canManageTemplates()
	)
}
